import { AlertTriangle, Phone } from "lucide-react";
import type { KickoutStepSchema } from "@schema-types/types/JourneySchema";

type ThemeWindow = {
  __THEME__?: {
    logoUrl?: string;
  };
};

export const KickoutStep = ({
  title,
  description,
  phoneNumber,
}: Pick<KickoutStepSchema, "title" | "description" | "phoneNumber">) => {
  const theme = typeof window !== "undefined" ? ((window as unknown as ThemeWindow).__THEME__ ?? {}) : {};
  const heading = title?.trim() || "Sorry, but we will not be able to process your claim";
  const problemDescription = description?.trim();
  const contactNumber = phoneNumber?.trim();

  return (
    <div className="space-y-8">
      <div className="flex flex-col items-center text-center">
        {theme.logoUrl ? (
          <img src={theme.logoUrl} alt="" className="mb-6 h-12 max-w-[200px] object-contain" />
        ) : null}
        <div className="mb-4 rounded-full bg-destructive/10 p-3 text-destructive">
          <AlertTriangle className="h-8 w-8" aria-hidden />
        </div>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">{heading}</h1>
        {problemDescription ? (
          <p className="mt-4 max-w-xl text-base text-muted-foreground">{problemDescription}</p>
        ) : (
          <p className="mt-4 max-w-xl text-base text-muted-foreground">
            Based on the information you provided, we cannot open a case for this claim.
          </p>
        )}
      </div>

      {contactNumber ? (
        <div className="rounded-lg border border-border bg-muted/30 p-6 text-center sm:p-8">
          <p className="text-sm font-medium text-foreground">If you would like to speak to someone, call us on</p>
          <a
            href={`tel:${contactNumber.replace(/\s+/g, "")}`}
            className="mt-3 inline-flex items-center gap-2 text-lg font-semibold text-primary hover:underline"
          >
            <Phone className="h-5 w-5" aria-hidden />
            {contactNumber}
          </a>
        </div>
      ) : null}
    </div>
  );
};
